import { render, staticRenderFns } from "./product_registration.vue?vue&type=template&id=adfd664c&scoped=true"
import script from "./product_registration.vue?vue&type=script&lang=js"
export * from "./product_registration.vue?vue&type=script&lang=js"
import style0 from "./product_registration.vue?vue&type=style&index=0&id=adfd664c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfd664c",
  null
  
)

export default component.exports